/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 公共头部
 * @Date: 2021-10-18 16:00:42
 * @LastEditTime: 2021-10-18 17:46:06
 */

import styles from "./index.less"

import { Modal, Button, Space, } from 'antd';
import { withRouter } from 'react-router-dom'
import classNames from "classnames";
import { connect } from 'react-redux'
import { getInfo, logout } from 'src/api'
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { getToken, removeToken, removePassword } from 'src/utils/auth.js'

const { confirm } = Modal;

class Header extends React.Component {

  state = {
    isShowOverlay: false,
    scrollTop: 0
  }
  componentDidMount() {
    getInfo().then(res => {
      if (res.code == 200) {
        this.props.dispatch({
          type: 'USERINFO',
          userInfo: res.user
        })
      }
    })
    // 页面滚动改变header
    let scrollPage = () => {
      this.setState({
        scrollTop: document.documentElement.scrollTop
      })
    }
    document.onscroll = scrollPage
    scrollPage();
  }
  logout = () => {
    confirm({
      title: '确定注销并退出系统吗？',
      centered: true,
      icon: <ExclamationCircleOutlined />,
      onOk() {
        logout(getToken()).then(() => {
          removeToken()
          removePassword()
          location.reload()
        })
      }
    });

  }
  render() {
    return (
      <header className={classNames("header flex align-items-center font-18", (this.state.scrollTop > 20 && ' light_header'), this.props.location.pathname == '/collaborationCenter' && 'dark-font')}>
        {/* logo */}
        <section className="flex align-items-center hover logo">
          {/* <ReactRouter.NavLink to='/'> */}
          <i className="iconfont icon-huasulogo-01" style={{ color: (this.props.location.pathname == '/' || this.state.scrollTop > 20 || this.props.location.pathname == '/collaborationCenter') ? '#1d2974' : '#fff' }}></i>
          {/* <img src={logo} alt="华苏浩睿AI门户" /> */}
          {/* </ReactRouter.NavLink> */}
          {/* <ReactRouter.NavLink to='/' className="nav-color"> */}
          <span className="ml-20 logo-title">Howso@ALGO</span>
          {/* </ReactRouter.NavLink> */}
        </section>
        {/* 导航 */}
        <ul className={classNames("flex nav mb-0", this.props.location.pathname == '/' && 'homePage')}>
          <li><ReactRouter.NavLink to='/' className={classNames(this.props.location.pathname == '/' && 'header-selected')}>首页</ReactRouter.NavLink></li>
          <li><ReactRouter.NavLink to='/algorithmList' className={classNames(this.props.location.pathname == '/algorithmList' && 'header-selected')}>解决方案</ReactRouter.NavLink></li>
          <li><ReactRouter.NavLink to='/collaborationCenter' className={classNames(this.props.location.pathname == '/collaborationCenter' && 'header-selected')}>协同中心</ReactRouter.NavLink></li>
        </ul>

        {/* 用户 */}
        <section className="user-box flex">



          {this.props.state.userInfo.userName
            ? <>
              <a href={process.env.common.LoginUrl} target="_blank">
                <span className="mr-30">
                  控制台
                </span>
              </a>
              <div className={styles.user} onMouseEnter={() => {
                this.setState({
                  isShowOverlay: true
                })
              }} onMouseLeave={() => this.setState({
                isShowOverlay: false
              })}>
                <Space size={4}>
                  <img src={this.props.state.userInfo.avatar || require('src/assets/images/profile.png')} alt="" />
                  {this.props.state.userInfo.userName}
                  <DownOutlined />
                </Space>
                <div className={classNames(styles.overlay, !this.state.isShowOverlay && styles.hidden)}>
                  <span onClick={this.logout}>退出登录</span>
                </div>
              </div>
            </>
            : <>
              <div className='title_btn'>
                <a href={process.env.common.LoginUrl + `/login?from=${location.href}`}>
                  <Button type="link">
                    <span>登录</span>
                  </Button>
                </a>
              </div>
            </>}

        </section>
      </header>

    )
  }

}
export default connect(
  state => {
    return {
      state
    }
  }
)(withRouter(Header))